import {TEMPLATE_ID} from "../actionTypes";

export const TemplateId = (id:any)=>{
    return(
        {
            type:TEMPLATE_ID,
            id:id,
        }
    )
}